import React, { useState, useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import CloseIcon from '@mui/icons-material/Close'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { closePopup } from '../../actions/uiActions'
import { createChildPresentation } from '../../actions/presentationActions'
import { withRouter } from '../../actions/withRouterHook'

function CreateStoryPopup(props) {
    let navigate = useNavigate();
    let [presentationName, setPresentationName] = useState("");
    let [sections, setSections] = useState([]);
    let [forceUpdate, setForceUpdate] = useState(false);

    // trigger on component mount
    useEffect(() => {
        if (presentationName === "") {
            setPresentationName(props.popupInfo.presentationView.presentation.name)
            buildSectionsObject(props.popupInfo.presentationView.slides)
        }
    })
    useEffect(() => {
        if (forceUpdate) {
            setForceUpdate(false)
        }
    }, [forceUpdate])

    return (
        <Dialog
            open={true}
            maxWidth={'md'}
            fullScreen={true}
            onClose={handleClick}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <CloseIcon onClick={handleClick} className="closePoup" />
            <DialogTitle id="alert-dialog-title" className="changepassdialog">
                Create New Story
            </DialogTitle>
            <DialogContent id="alert-dialog-description" className="slide-selector-container">
                <Grid container spacing={3} style={{ marginBottom: 5, marginTop: 5 }} className="slide-selector-container-form">
                    <Grid item xs={10}><input type="text" value={presentationName} onChange={changeName} /></Grid>
                    <Grid item xs={2}>
                        <button className="btn" type="submit" onClick={handleSubmit} disabled={shouldSubmitButtonBeDisabled(sections)} value="Submit" id="submit_btn">
                            Create
                        </button>
                    </Grid>
                </Grid>
                {sections.map((section, sectionIndex) => {
                    return (<Accordion key={`section-${sectionIndex}`}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography style={{ fontSize: 14, fontWeight: 400 }}>{section.key}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container spacing={3} style={{marginLeft: "-12px"}}>
                                {section.slides.map((slide, slideIndex) => {
                                    return (<Grid item key={`section-story-slide-item-${sectionIndex}-${slideIndex}`} xs={4} md={3} className={slide.isSelected ? "slide-selector slide-selector-selected" : "slide-selector"}>
                                        <Typography variant="caption" display="block" gutterBottom align="center" onClick={(e) => handleCheckChanged(e, slide.slideTag)}>
                                            {slide.slideTag}
                                        </Typography>
                                        <img src={`data:image/jpeg;base64,${slide.slide.slideImage.imageBytes}`} alt={slide.slide.slideTag} onClick={(e) => handleCheckChanged(e, slide.slideTag)} style={{ height: 'auto', width: '100%' }} />
                                        <Typography variant="caption" display="block" gutterBottom align="center" onClick={(e) => handleCheckChanged(e, slide.slideTag)}>
                                            {slide.slide.slideDescription}
                                        </Typography>
                                    </Grid>)
                                })}
                            </Grid>
                        </AccordionDetails>
                    </Accordion>);
                })}
            </DialogContent>
        </Dialog>
    )

    function buildSlideObject(slide) {
        return {
            "isSelected": false,
            "slideNumber": slide["slideNumber"],
            "slideTag": slide["slideTag"],
            "slide": slide
        }
    }
    function buildSectionsObject(slides) {
        let sections = {}
        let rtnVal = []

        slides.forEach(s => {
            let currentSection = s.section
            if (!sections[currentSection]) {
                sections[currentSection] = true
            }
        })

        // Go through each key and build the objects
        Object.keys(sections).forEach(key => {
            let slidesInSection = []

            slides.forEach(s => {
                if (s.section === key) {
                    slidesInSection.push(buildSlideObject(s))
                }
            })

            rtnVal.push({
                "key": key,
                "slides": slidesInSection
            })
        })

        setSections(rtnVal)
    }
    function shouldSubmitButtonBeDisabled(objects) {
        let rtnVal = true

        objects.forEach((obj) => {
            obj.slides.forEach(slide => {
                if (slide["isSelected"] === true) {
                    rtnVal = false
                }
            })
        })

        return rtnVal
    }
    function getAllSelectedSlideTags() {
        let rtnVal = []

        sections.forEach(section => {
            section.slides.forEach(slide => {
                if (slide["isSelected"] === true) {
                    rtnVal.push(slide["slideTag"])
                }
            })
        })

        return rtnVal
    }

    function handleClick(event) {
        event.preventDefault()
        props.closePopup()
    }
    function handleSubmit(event) {
        event.preventDefault()
        props.closePopup()

        props.createChildPresentation(props.popupInfo.presentationView.id, presentationName, getAllSelectedSlideTags())
        navigate('/presentations')
    }
    function handleCheckChanged(event, tag) {
        event.preventDefault()

        sections.forEach(section => {
            let slides = section.slides

            slides.forEach((slide) => {
                if (slide.slideTag === tag) {
                    slide.isSelected = !slide.isSelected
                }
            })
        })

        setSections(sections)
        setForceUpdate(true)
    }
    function changeName(event) {
        event.preventDefault()
        setPresentationName(event.target.value)
    }
}

function mapStateToProps(state) {
    return {
        popupInfo: state.ui.popupInfo,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup, createChildPresentation }, dispatch)
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CreateStoryPopup))